import React from 'react';
// import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
//import 'react-tabs/style/react-tabs.css';
import Dropdown from 'react-dropdown';
import { IconClose } from '../../img';
import { UpgradePlanCard } from '../../components';
//import { SketchPicker } from 'react-color';
// import './Wall.scss';

let optnRating = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
];

const FilterCard = ({
  widgetById,
  handleWidgetChange,
  handleInputchange,
  handleEnterEvent,
  excludeChips,
  includeChips,
  removeChips,
  handleUpgradePlan
}) => {
  return (
    <div className="card card-editor card-header">
      <div className="card-editor-block p-0">
        <div className='card-plan-div'>
          <label className="card-editor-title">Filter</label>
          <UpgradePlanCard
            handleUpgradePlan={handleUpgradePlan}
          />
        </div>
        <div className="header-list">
          {widgetById && widgetById.ihwc != undefined &&
            <div className="editor-toggle customize-dropdown toggle-header-dply hide-out-com">
              <label className="label-title">Hide without comment</label>
              <label className="switch">
                <input type="checkbox" checked={widgetById.ihwc} onChange={(e) => handleWidgetChange('ihwc', e.target.checked)} />
                <span className="slider round"></span>
              </label>
            </div>
          }
          {widgetById && widgetById.ihwi != undefined &&
            <div className="editor-toggle customize-dropdown toggle-header-dply hide-out-img">
              <label className="label-title">Hide without image/video </label>
              <label className="switch">
                <input type="checkbox" checked={widgetById.ihwi} onChange={(e) => handleWidgetChange('ihwi', e.target.checked)} />
                <span className="slider round"></span>
              </label>
            </div>
          }
          {widgetById && widgetById.mnrt != undefined &&
            <div className="editor-dropdown customize-dropdown customize-rows">
              <label>Minimum rating</label>
              <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={optnRating} value={widgetById.mnrt != undefined ? widgetById.mnrt.toString() : widgetById.mnrt} onChange={(e) => handleWidgetChange('mnrt', e.value)} />
            </div>
          }
          {widgetById && widgetById.inkw != undefined &&
            <div className="editor-input header-editor-ckeditor editor-header-title">
              <label className="label-title">Include keyword</label>
              <input className="editor-input-content editor-input-fullwidth editor-input-inckey" type="text" placeholder='Enter keyword and press enter' value={includeChips} onChange={(e) => handleInputchange('includeChips', e.target.value)} onKeyDown={(e) => handleEnterEvent('inkw', e)}></input>
              <div className="chips-block">
                {
                  widgetById.inkw.length > 0 ?
                    <ul className="chips-list">
                      {
                        widgetById.inkw.map((val, key) => {
                          return (
                            <li key={key}>{val}<i onClick={() => removeChips('inkw', key)}><img src={IconClose} /></i></li>
                          );
                        })
                      }
                    </ul>
                    : null
                }
              </div>
            </div>
          }
          {
            widgetById && widgetById.exkw != undefined &&
            <div className="editor-input header-editor-ckeditor editor-header-caption">
              <label className="label-title">Exclude keyword</label>
              <input className="editor-input-content editor-input-fullwidth editor-input-exdkey" type="text" placeholder='Enter keyword and press enter' value={excludeChips} onChange={(e) => handleInputchange('excludeChips', e.target.value)} onKeyDown={(e) => handleEnterEvent('exkw', e)}></input>
              <div className="chips-block">
                {
                  widgetById.exkw.length > 0 ?
                    <ul className="chips-list">
                      {
                        widgetById.exkw.map((val, key) => {
                          return (
                            <li key={key}>{val}<i onClick={() => removeChips('exkw', key)}><img src={IconClose} /></i></li>
                          );
                        })
                      }
                    </ul>
                    : null
                }
              </div>
            </div>
          }

          {/* {widgetById && widgetById.itwtpst &&
            <div className="editor-toggle customize-dropdown toggle-header-dply">
              <label className="label-title">Show original tweet</label>
              <label className="switch">
                <input type="checkbox" checked={widgetById.itwtpst} onChange={(e) => handleWidgetChange('itwtpst', e.target.checked)} />
                <span className="slider round"></span>
              </label>
            </div>
          }
          {widgetById && widgetById.itwtrpls &&
            <div className="editor-toggle customize-dropdown toggle-header-dply">
              <label className="label-title">Show reply tweet</label>
              <label className="switch">
                <input type="checkbox" checked={widgetById.itwtrpls} onChange={(e) => handleWidgetChange('itwtrpls', e.target.checked)} />
                <span className="slider round"></span>
              </label>
            </div>
          }
          {widgetById && widgetById.itwtrtwt &&
            <div className="editor-toggle customize-dropdown toggle-header-dply">
              <label className="label-title">Show re-tweet</label>
              <label className="switch">
                <input type="checkbox" checked={widgetById.itwtrtwt} onChange={(e) => handleWidgetChange('itwtrtwt', e.target.checked)} />
                <span className="slider round"></span>
              </label>
            </div>
          } */}
        </div>
      </div>
    </div>
  );
};
export default FilterCard;


// WEBPACK FOOTER //
// ./src/components/Widget/FilterCard.js